"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function fuel(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M19.149 7.50001H14.2778L12.8333 11.1225H8.27775V9.25726H12.8333L13.5 7.50001H6.6015C6.5161 7.49961 6.43402 7.5331 6.37328 7.59314C6.31254 7.65318 6.27809 7.73486 6.2775 7.82026V11.1218H5.1675L4.5 12.8783H6.2775V16.176C6.2775 16.3545 6.4245 16.5 6.606 16.5H9.94425L10.611 14.7443H8.27775V12.8775H12.0555L10.611 16.5H12.8333L14.3888 12.8775H19.1737C19.3538 12.8775 19.5 12.7335 19.5 12.5558V7.84576C19.4992 7.75339 19.4618 7.66512 19.396 7.6003C19.3302 7.53548 19.2414 7.49941 19.149 7.50001ZM17.6115 10.845C17.6115 10.998 17.4862 11.1225 17.331 11.1225H15.0555L15.8333 9.25801H17.3295C17.4036 9.25721 17.4749 9.28581 17.5279 9.33755C17.5809 9.38929 17.6113 9.45994 17.6122 9.53401L17.6115 10.845Z", fill: color }));
}
exports["default"] = fuel;
//# sourceMappingURL=fuel.js.map